var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',{staticClass:"word"},[_vm._v("\n    "+_vm._s(_vm.keyword)+"\n  ")]),_c('button',{staticClass:"rm",on:{"click":function($event){return _vm.$emit('removeKeyword', _vm.keyword)}}},[_vm._v("\n    ×\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }